import styled, { css } from 'styled-components';

const firstCell = css`
  text-align: left;
  padding-left: 10px;
  font-weight: 600;
  font-size: 13px;
  color: ${(props) => props.theme.timesheetsTableTextSecondaryColor};
`;

const firstCellMobile = css`
  width: 163px;
  text-align: left;
  padding-left: 10px;
  font-weight: 600;
  font-size: 13px;
  color: ${(props) => props.theme.timesheetsTableTextSecondaryColor};
`;

const middleCells = css`
  text-align: center;
  color: ${(props) => props.theme.timesheetsSumHoursColor};
  font-weight: 700;
  position: relative;
`;

const middleCellsMobile = css`
  text-align: center;
  color: ${(props) => props.theme.timesheetsSumHoursColor};
  font-weight: 700;
  position: relative;
`;

export const TableRowFooterCell = styled.th<{
  firstRow: boolean;
  isMobile: boolean;
  isDataCell?: boolean;
}>`
  ${({ firstRow, isMobile, isDataCell }) => {
    if (firstRow && !isDataCell) {
      if (isMobile) {
        return firstCellMobile;
      } else {
        return firstCell;
      }
    } else {
      if (isMobile) {
        return middleCellsMobile;
      } else {
        return middleCells;
      }
    }
  }}
  background-color: ${(props) => props.theme.timesheetsTableHeaderBackground};
  vertical-align: middle;
  border: 1px solid ${(props) => props.theme.timesheetsTableBorderColor};
`;

const successHours = css`
  background-color: #6bb700;
`;

const warningHours = css`
  background-color: #ffb64e;
`;

export const RequiredHours = styled.div<{
  isRequiredHour: boolean;
  status: boolean;
}>`
  ${({ isRequiredHour, status }) => {
    if (isRequiredHour) {
      if (status) {
        return successHours;
      } else {
        return warningHours;
      }
    } else {
      return 'display: none;';
    }
  }}

  height: 6px;
  border-radius: 5px;
  width: 80%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: -3px;
  margin: auto;
`;
